import { useContext } from "react";
import { searchContext } from "@/pages/search/searchHooks/SearchContext";
import { searchPaginationContext } from "@/pages/search/searchHooks/SearchPaginationContext";
import { isAutosScreen } from "@/pages/search/searchHooks/filtersHelpers";
import { useLocation } from "react-router-dom";
export default function useFilterPage() {
  var location = useLocation();
  if (isAutosScreen(location)) {
    return useContext(searchPaginationContext);
  }
  return useContext(searchContext);
}
export function useSearchResultsData() {
  var location = useLocation();
  if (isAutosScreen(location)) {
    return useContext(searchPaginationContext).searchResults;
  }
  return useContext(searchContext).searchResults;
}